// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExperimentTwoToneSvg from "@fishx/icons-svg/es/asn/ExperimentTwoTone";
import FishxIcon from '../components/FishxIcon';

var ExperimentTwoTone = function ExperimentTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentTwoToneSvg
  }));
};

ExperimentTwoTone.displayName = 'ExperimentTwoTone';
export default React.forwardRef(ExperimentTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExperimentTwoTone.js
// module id = 2641
// module chunks = 0